import React from "react";

import useWindowDimensions from "../../hooks/useWindowDimensions";

import { Layout } from "../../components";
import LetsTalk from "../../components/contact/LetsTalk";
import ContactUs from "../../components/contact/ContactUs";
import MENU_PATHS from "../../constants/menu";
import SEO from "../../components/seo/SEO";

const Contact = () => {
  const { isSmallScreen } = useWindowDimensions();

  const seo = {
    title: `SND | Contact`,
    pathname: MENU_PATHS.CONTACT,
  };

  return (
    <Layout stores={false} height={80} withoutHero={true}>
      <SEO {...seo} />
      <div className="_wr">
        <div className="_w">
          <div className="_12">
            <section
              className={`m-contact fullWidth aligned-start ${
                isSmallScreen ? "column" : ""
              } spacing-50`}
            >
              <LetsTalk />
              <ContactUs />
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Contact;
